const getAttestations = (state) => state.attestations;

export default {
  getAttestations,
};
